import React, { useEffect } from 'react';
import { ScriptQuestionDataFragment } from '@vette/data-access';
import {
  Form,
  FormItem,
  RadioGroup,
  useAnswersSubForm,
} from '@vette/ui-components';
import { FormInstance, Radio } from 'antd';
import { FormItemNames, FormType } from './form';

type Props = {
  form: FormInstance<FormType>;
  questions: ScriptQuestionDataFragment[];
  disabled?: boolean;
};

export const KnockoutQuestions: React.FC<Props> = ({
  form,
  questions,
  disabled,
}) => {
  const { answersForm, handleAnswersFormChange } = useAnswersSubForm({
    form,
    fieldName: FormItemNames.knockoutAnswers,
  });

  useEffect(() => {
    const originalSubmit = form.submit;
    // Intercept the form submission and validate the knockout questions
    form.submit = async () => {
      await Promise.all([form.validateFields(), answersForm.validateFields()]);
      return await originalSubmit();
    };
  }, [form, answersForm]);

  return (
    <Form form={answersForm} onValuesChange={handleAnswersFormChange}>
      {questions.map(question => (
        <FormItem
          labelCol={{ style: { display: 'flex' } }}
          redLabelOnError
          key={question.id}
          name={question.id.toString()}
          label={question.title}
          rules={[
            {
              validator: (_: unknown, value: unknown) => {
                if (!value) return Promise.reject();
                return Promise.resolve();
              },
            },
          ]}
        >
          <RadioGroup disabled={disabled}>
            {question.metadata.options.map((option: string) => (
              <Radio
                aria-label={`Knockout: ${option}`}
                disabled={disabled}
                key={option}
                value={option}
              >
                {option}
              </Radio>
            ))}
          </RadioGroup>
        </FormItem>
      ))}
    </Form>
  );
};
